var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c(
        "div",
        { staticClass: "search-box", style: _vm.boxStyle },
        [
          _vm.configObj.searConfig.tabVal === 1
            ? [
                _vm.configObj.logoConfig.isShow === 1 && _vm.logoUrl
                  ? _c("img", {
                      attrs: { src: _vm.logoUrl, alt: "", mode: "widthFix" },
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm.configObj.searConfig.tabVal === 2
            ? [
                _c("div", { staticClass: "acea-row map row-middle location" }, [
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.configObj.searchConfig.tabVal === 0,
                        expression: "configObj.searchConfig.tabVal===0",
                      },
                    ],
                    staticClass: "iconfont icon-dingwei1 font14",
                  }),
                  _c("span", { staticClass: "ml2" }, [_vm._v("国润城")]),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.configObj.searchConfig.tabVal === 1,
                        expression: "configObj.searchConfig.tabVal===1",
                      },
                    ],
                    staticClass: "iconfont icon-caozuo-xia font14 ml2",
                  }),
                ]),
              ]
            : _vm._e(),
          _c("div", { staticClass: "box", style: _vm.contentStyle }, [
            _c("span", { staticClass: "line1" }, [
              _c("i", { staticClass: "el-icon-search" }),
              _c("span", [_vm._v(_vm._s(_vm.hotWord))]),
            ]),
          ]),
          _vm._m(0),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "capsule" }, [
      _c("img", {
        attrs: { src: require("@/assets/imgs/capsule.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }